module.exports = __webpack_public_path__ + "static/Lich_2-861d5559889fb8754bc99a857e199715.jpg";